import { snapshot } from "valtio/vanilla";
import * as API from "../../../api/osMapPrint";
import { abortOsMapPrintRequest } from "./abortOsMapPrintRequest";
import { osMapPrintStore } from "../store";
import { updateStore } from "./updateStore";

export const purchase = async (useSavedCard: boolean, paymentSourceId: string) => {
  updateStore({
    saving: true,
  });
  const { sku_id, orientation, center, site_id } = snapshot(osMapPrintStore);
  if (sku_id) {
    abortOsMapPrintRequest();
    const payload: API.PurchasePayload = {
      orientation,
      center,
      site_id,
    };
    if (useSavedCard) {
      payload.card_id = paymentSourceId;
    } else {
      payload.token = paymentSourceId;
    }
    try {
      const result = await API.purchase(sku_id, payload);
      if (result) {
        const {
          abort,
          response: { _id: print_id, ...response },
        } = result;
        updateStore({
          ...response,
          print_id,
          activeRequestAbort: abort,
        });
      }
    } catch (error) {
      updateStore({
        saving: false,
      });
      throw error;
    }
  }
  updateStore({
    saving: false,
  });
};
